import moment from 'moment'

var store = {
  init (initialState) {
    this.state.url = initialState.url
    this.state.uporabnik = initialState.uporabnik
    this.state.lang = initialState.lang
    this.state.emailLang = initialState.lang
    this.state.isHkom = initialState.hkom
    this.state.maxValid = initialState.maxValid // Number: 7
    this.state.up_email = initialState.email
    this.state.defaultValidDate = initialState.defaultValidDate // String: 18.9.2018
    this.state.defaultValid = initialState.defaultValid // Number: 30

    if (this.state.defaultValidDate) {
      let validDate = new Date(moment().add(this.state.defaultValid, 'days').format('MM/DD/YYYY'))
      let maxValidDate = new Date(moment().add(this.state.maxValid, 'days').format('MM/DD/YYYY'))
      this.state.maxDate = maxValidDate
      if (this.state.maxValid <= this.state.defaultValid) {
        this.state.date = maxValidDate
      } else {
        this.state.date = new Date(validDate)
      }
    }
  },

  state: {
    recipients: [],
    uporabnik: null,
    lang: null,
    files: [],
    url: null,
    isHkom: false,
    encrypt: true,
    notify: true,
    sendPw: 'NONE',
    date: null,
    maxDate: null,
    datum: null,
    message: null,
    comment: null,
    errors: {},
    password: null,
    emailLang: null,
    addresses: [],
  },
  addRecipient (data) {
    this.state.recipients.push(data)
  },
  updateRecipient (index, data) {
    this.state.recipients[index] = data
  },
  removeRecipient (index) {
    this.state.recipients.splice(index, 1)
  },
  clearRecipients () {
    this.state.recipients = []
  },
  addFiles (file) {
    let a = this.state.files
    a.push(file)
    this.state.files = a
  },
  removeFile (fileId) {
    for (var i = 0; i < this.state.files.length; i++) {
      if (this.state.files[i].id === fileId) {
        this.state.files.splice(i, 1)
      }
    }
  },
  resetStore () {
    this.state.recipients = []
    this.state.files = []
    this.state.url = null
    this.state.isHkom = false
    this.state.encrypt = true
    this.state.notify = true
    this.state.sendPw = 'NONE'
    this.state.date = null
    this.state.maxDate = null
    this.state.datum = null
    this.state.message = null
    this.state.comment = null
    this.state.errors = {}
    this.state.password = null
    this.state.addresses = []
    this.state.emailLang = null
  },
  setLang(value) {
    this.state.lang = value
  },
  setEmailLang (value) {
    this.state.emailLang = value
  },
  setEncrypt (value) {
    this.state.encrypt = value
  },
  setNotify (value) {
    this.state.notify = value
  },
  setSendPw (value) {
    this.state.sendPw = value
  },
  setUrl (value) {
    this.state.url = value
    this.resetError('url')
  },
  setDate (value) {
    this.state.date = value
    this.resetError('datum')
  },
  setMessage (value) {
    this.state.message = value
  },
  setComment (value) {
    this.state.comment = value
  },
  setPassword (value) {
    this.state.password = value
  },
  setErrors (value) {
    this.state.errors = value
  },
  setError (k, value) {
    let a = this.state.errors
    a[k] = value
    this.state.errors = a
  },
  resetError (value) {
    if (this.state.errors[value]) {
      this.setErrors({})
    }
  },
  setAddresses (value) {
    this.state.addresses = value
  },
  resetAddresses (value) {
    this.state.addresses = []
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store.js